import { render, staticRenderFns } from "./DepartmentUserRow.vue?vue&type=template&id=31ab1ffe&scoped=true"
import script from "./DepartmentUserRow.vue?vue&type=script&lang=js"
export * from "./DepartmentUserRow.vue?vue&type=script&lang=js"
import style0 from "./DepartmentUserRow.vue?vue&type=style&index=0&id=31ab1ffe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab1ffe",
  null
  
)

export default component.exports